<template>
  <b-modal
    v-model="show_"
    :title="$t('tabs.settings.change_password.modal.title')"
    hide-footer
  >
    <form
      :data-vv-scope="formName"
      @submit.prevent="onSubmit"
    >
      <div class="form-group mb-4">
        <label for="updateOldPassword-input">
          {{ $t(`${tt}.old_password.label`) }}
        </label>
        <input
          id="updateOldPassword-input"
          v-model="itemData.old_password"
          v-validate="'required'"
          name="old_password"
          :data-vv-as="$t(`${tt}.old_password.label`).toLowerCase()"
          :data-vv-scope="formName"
          type="password"
          class="form-control"
          :placeholder=" $t(`${tt}.old_password.placeholder`)"
          :class="{'is-invalid': errors.has(`${formName}.old_password`)}"
        >
        <span
          v-if="errors.has(`${formName}.old_password`)"
          class="invalid-feedback"
          v-html="errors.first(`${formName}.old_password`)"
        />
      </div>

      <div class="form-group mb-4">
        <label for="updateNewPassword-input">
          {{ $t(`${tt}.new_password.label`) }}
        </label>
        <input
          id="updateNewPassword-input"
          v-model="itemData.new_password"
          v-validate="'required|min:8'"
          name="new_password"
          :data-vv-as="$t(`${tt}.old_password.label`).toLowerCase()"
          :data-vv-scope="formName"
          type="password"
          class="form-control"
          :placeholder=" $t(`${tt}.new_password.placeholder`)"
          :class="{'is-invalid': errors.has(`${formName}.new_password`)}"
        >
        <span
          v-if="errors.has(`${formName}.new_password`)"
          class="invalid-feedback"
          v-html="errors.first(`${formName}.new_password`)"
        />
      </div>

      <div class="form-group mb-4">
        <label for="updateRepeatNewPassword-input">
          {{ $t(`${tt}.repeat_new_password.label`) }}
        </label>
        <input
          id="updateRepeatNewPassword-input"
          v-model="itemData.repeat_new_password"
          v-validate="'required|confirmed:new_password'"
          name="repeat_new_password"
          :data-vv-as="$t(`${tt}.old_password.label`).toLowerCase()"
          :data-vv-scope="formName"
          type="password"
          class="form-control"
          :placeholder=" $t(`${tt}.repeat_new_password.placeholder`)"
          :class="{'is-invalid': errors.has(`${formName}.repeat_new_password`)}"
        >
        <span
          v-if="errors.has(`${formName}.repeat_new_password`)"
          class="invalid-feedback"
          v-html="errors.first(`${formName}.repeat_new_password`)"
        />
      </div>

      <div class="text-right pt-5 mt-3">
        <b-button
          variant="link"
          @click="show_ = false"
        >
          {{ $t(`${tt}.button.close`) }}
        </b-button>
        <b-button
          type="submit"
          :disabled="submit"
          variant="primary"
          class="ml-1"
        >
          {{ $t(`${tt}.button.save`) }}
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import ModalShowMixins from "@/mixins/ModalShowMixins";
import catchDispatch from "@/utils/catchDispatch";
import FormMixins from "../../../../mixins/FormMixins";
import FormResetShowMixins from "../../../../mixins/FormResetShowMixins";

export default {
  mixins: [
    ModalShowMixins,
    FormMixins,
    FormResetShowMixins,
  ],
  data: () => ({
    tt: 'tabs.settings.change_password.modal.form',
    formName: 'change-password',
    submit: false,
    itemData: {
      old_password: '',
      new_password: '',
      repeat_new_password: '',
    },
  }),
  computed: {
    ...mapGetters('auth', ['user']),
  },
  methods: {
    async onSubmit() {
      const valid = await this.onSubmitValid();
      if (!valid) return;

      axios
        .put(`/entities/api/v1/users/${this.user.id}/password/update`, this.itemData)
        .then(({data}) => {
          this.$store.commit('auth/SET_USER', data)
          this.show_ = false;
        })
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.submit = false);
    },
  },
}
</script>

<style scoped>

</style>
